// extracted by mini-css-extract-plugin
export default {"label":"FormFieldTemp_label","input":"FormFieldTemp_input"};